import { sendEvent } from '@local/services/webApi';

const isLoggingEnabled = __IS_AZURE_EVENT_HUBS_ENABLED__ === 'true';

export default function logEvent(eventCode, data) {
  if (eventCode && isLoggingEnabled) {
    const sessionId = sessionStorage.getItem('sessionId') || '';
    const idToken = sessionStorage.getItem('idToken') || '';
    sendEvent({ sessionId, idToken, eventCode, data }).catch(() => {});
  }
}
